import { ApolloQueryResult, OperationVariables } from '@apollo/client'

import { ComLog, ComlogData } from '../../../types/monitoring'
import MonitoringFormListRowDesktop from './MonitoringFormListRowDesktop'
import MonitoringFormListRowSkeleton from './MonitoringFormListRowSkeleton.skeleton'
import MonitoringFormListTableHeadDesktop from './MonitoringFormListTableHeadDesktop'

interface MonitoringFormListDesktopProps {
  listData: ComLog[] | undefined
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      comLogs: ComlogData
    }>
  >
}
const MonitoringFormListDesktop: React.FC<MonitoringFormListDesktopProps> = ({
  listData,
  refetch
}) => {
  return (
    <div>
      <MonitoringFormListTableHeadDesktop refetch={refetch} />
      {listData
        ? listData.map((item, index) => (
            <MonitoringFormListRowDesktop
              data={item}
              key={item.Id + index.toString()}
            />
          ))
        : Array(8)
            .fill(null)
            .map((item, index) => (
              <MonitoringFormListRowSkeleton key={index.toString()} />
            ))}
    </div>
  )
}
export default MonitoringFormListDesktop
